import React from 'react'
import {
  AirportShuttle,
  DirectionsBoat,
  DirectionsCar,
  DirectionsWalk,
  Festival,
  Flight,
  Groups,
  LocalHospital,
  MedicalServices,
  PedalBike,
  Pets,
  Place,
  SettingsInputAntenna,
  Shield,
  TwoWheeler,
} from '@mui/icons-material'
import AmbulanceIcon from '../../../../assets/icons/Ambulance'

// Icons a dispatcher can pick per resource; the choice is stored as
// CADResource.icon (the `key`) and drives the map marker + resource card.
// Keys are the server-side whitelist too (resourceActions.js) — keep in sync.
export const RESOURCE_ICONS = [
  { key: 'ambulance', label: 'Ambulance', Icon: null }, // custom SVG below
  { key: 'car', label: 'Car / RRV', Icon: DirectionsCar },
  { key: 'van', label: 'Van / Minibus', Icon: AirportShuttle },
  { key: 'motorbike', label: 'Motorbike', Icon: TwoWheeler },
  { key: 'bicycle', label: 'Bicycle', Icon: PedalBike },
  { key: 'foot', label: 'On foot', Icon: DirectionsWalk },
  { key: 'team', label: 'Team', Icon: Groups },
  { key: 'boat', label: 'Boat', Icon: DirectionsBoat },
  { key: 'aircraft', label: 'Aircraft', Icon: Flight },
  { key: 'hospital', label: 'Medical centre', Icon: LocalHospital },
  { key: 'firstaid', label: 'First aid post', Icon: MedicalServices },
  { key: 'tent', label: 'Tent', Icon: Festival },
  { key: 'control', label: 'Control / radio', Icon: SettingsInputAntenna },
  { key: 'officer', label: 'Officer', Icon: Shield },
  { key: 'mounted', label: 'Mounted / dog unit', Icon: Pets },
  { key: 'place', label: 'Fixed point', Icon: Place },
]

// Sensible marker when a resource has no explicit icon yet.
const TYPE_DEFAULTS = {
  Ambulance: 'ambulance',
  RRV: 'car',
  'Response Team': 'foot',
  'Medical Centre': 'hospital',
  Officer: 'officer',
}

export const resolveResourceIconKey = (resource) => {
  const explicit = resource?.icon
  if (explicit && RESOURCE_ICONS.some((option) => option.key === explicit)) {
    return explicit
  }
  return TYPE_DEFAULTS[resource?.type] || 'ambulance'
}

export const ResourceIcon = ({ iconKey, size = 16, color = 'currentColor', sx }) => {
  const option =
    RESOURCE_ICONS.find((entry) => entry.key === iconKey) || RESOURCE_ICONS[0]

  if (!option.Icon) {
    return <AmbulanceIcon width={size} height={size} color={color} />
  }

  const Icon = option.Icon
  return <Icon sx={{ fontSize: size, color, display: 'block', ...sx }} />
}
